import i18n from "../../i18n";

// The option values stay English (they are stored and matched by the backend);
// only what the user reads is translated.
const KEYS: Record<string, Record<string, string>> = {
  gender: { Male: "male", Female: "female", Other: "other", "Prefer not to say": "preferNot" },
  lookingFor: {
    Friendship: "friendship",
    "Relationship/Dating": "dating",
    "Business Partnership": "business",
    "Travel Buddy": "travel",
    "Study Partner": "study",
    "Just Chat/Meet New People": "chat",
    Other: "other",
  },
  interest: {
    Music: "music", Travel: "travel", Food: "food", Sports: "sports", Art: "art",
    Technology: "technology", Books: "books", Movies: "movies", Nature: "nature",
    Fitness: "fitness", Gaming: "gaming", Other: "other",
  },
  personality: { Introvert: "introvert", Extrovert: "extrovert", Ambivert: "ambivert" },
  communication: { Direct: "direct", Soft: "soft", Playful: "playful" },
  value: {
    honesty: "honesty", loyalty: "loyalty", senseOfHumor: "senseOfHumor", ambition: "ambition",
    kindness: "kindness", intelligence: "intelligence", physicalAttraction: "physicalAttraction",
  },
};

export const optionLabel = (group: keyof typeof KEYS, value: string): string => {
  const key = KEYS[group]?.[value];
  return key ? i18n.t(`social.option.${group}.${key}`) : value;
};

export const statusLabel = (status: string): string =>
  ["pending", "accepted", "rejected", "expired"].includes(status)
    ? i18n.t(`social.status.${status}`)
    : status;

// Backend match-detail words ("Good", "Similar", ...) in the user's language.
export const matchDetailLabel = (value: string): string =>
  i18n.t(`social.matches.detail.${value}`, { defaultValue: value });
